<template>
  <div>
    <search-sim-card-inventory-statistic
      :carrier-type="carrierType"
      @submit="submitSearch"
    />

    <a-table
      size="middle"
      :scroll="{ x: 'max-content' }"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      row-key="id"
    >
      <span slot="is_alarm" slot-scope="text">
        {{ text ? '是' : '否' }}
      </span>

      <span slot="alarm_value" slot-scope="text, record">
        {{ record.is_alarm ? text : '-' }}
      </span>

      <span slot="actions" slot-scope="text, record">
        <a
          v-if="isHasSetAlarmPermission"
          @click="showSetAlarmModal(record.id, record.is_alarm, record.alarm_type, record.alarm_value)"
        >告警配置</a>
      </span>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

    <set-alarm
      v-if="isShowSetAlarmModal"
      :visible.sync="isShowSetAlarmModal"
      :alarm-id="settingAlarmId"
      :is-alarm="isAlarm"
      :alarm-type="alarmType"
      :alarm-value="alarmValue"
      @completed="fetchData"
    />
  </div>
</template>

<script>
import { hasPermission } from '@/utils/permission'
import { findSimCardInventoryStatistics } from '@/api/sim_card_inventory'
import Pagination from '@/components/Pagination'
import SearchSimCardInventoryStatistic from '@/views/sim_card_inventories/statistics/Search'

export default {
  name: 'SimCardInventoryStatisticList',
  components: {
    Pagination,
    SearchSimCardInventoryStatistic,
    SetAlarm: () => import('@/views/sim_card_inventories/statistics/SetAlarm')
  },
  data() {
    return {
      data: [],
      loading: true,
      isShowSetAlarmModal: false,
      settingAlarmId: 0,
      isAlarm: false,
      alarmType: 1,
      alarmValue: 0,
      pagination: {
        total_count: 0
      },
      query: {}
    }
  },
  created() {
    this.fetchData()
  },
  watch: {
    '$route.meta.carrier_type'() {
      this.query = Object.assign({}, this.$options.data().query, { per_page: this.query.per_page })
      this.fetchData()
    }
  },
  computed: {
    carrierType() {
      return this.$route.meta.carrier_type
    },

    columns() {
      return [
        { title: '流量场景', dataIndex: 'traffic_scene_name', width: 160 },
        { title: '服务周期', dataIndex: 'service_cycle_name', width: 160 },
        { title: '卡板材质', dataIndex: 'card_type_name', width: 140 },
        { title: '卡片尺寸', dataIndex: 'card_shape_name', width: 120 },
        { title: '库存数量', dataIndex: 'inventory_count', width: 120 },
        { title: '是否告警', dataIndex: 'is_alarm', width: 100, scopedSlots: { customRender: 'is_alarm' }},
        { title: '告警数量', dataIndex: 'alarm_value', width: 120, scopedSlots: { customRender: 'alarm_value' }},
        { title: '操作', dataIndex: 'actions', width: 120, scopedSlots: { customRender: 'actions' }}
      ]
    },

    isHasSetAlarmPermission() {
      return hasPermission('sim_card_inventory_statistics/set_alarm') || hasPermission('sim_card_inventories')
    }
  },
  methods: {
    showSetAlarmModal(alarmId, isAlarm, alarmType, alarmValue) {
      this.settingAlarmId = alarmId
      this.isAlarm = isAlarm

      if (isAlarm) {
        this.alarmType = alarmType || 1
        this.alarmValue = alarmValue
      } else {
        this.alarmType = 1
        this.alarmValue = 0
      }

      this.isShowSetAlarmModal = true
    },

    submitSearch(search) {
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search)
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      findSimCardInventoryStatistics(Object.assign({}, this.query, {
        carrier_type: this.carrierType
      })).then((res) => {
        this.data = res.data
        this.pagination = res.pagination
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
